import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "copyValue"
    ]

    copy(event) {
        navigator.clipboard.writeText(this.copyValueTarget.innerText).then(function () {
            const button = event.target
            const originalText = button.textContent

            button.textContent = 'Kopiert!'
            button.classList.add('bg-green-700!', 'hover:bg-green-800!')
            button.disabled = true

            setTimeout(() => {
                button.textContent = originalText
                button.classList.remove('bg-green-700!', 'hover:bg-green-800!')
                button.disabled = false
            }, 2000)

        }, function (err) {
            console.error('[CopyToClipboardController] Could not copy text: ', err)
        })
    }
}
